<script lang="ts" setup>
import { useVoipRoomStore } from '../model/voip-room-store'
import LiveKitButtonCamera from './livekit/LiveKitButtonCamera.vue'

defineOptions({
  name: 'ButtonCamera',
})

const voipRoomStore = useVoipRoomStore()
</script>

<template>
  <LiveKitButtonCamera v-if="voipRoomStore.isLiveKitRoom" />
</template>
